var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurgeryTools(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90321 19.1211H20.8667C21.267 19.1211 21.5987 19.5512 21.5987 20.0605C21.5987 20.5697 21.267 20.9998 20.8667 20.9998H1.73199C1.34312 20.9998 1 20.5697 1 20.0605C1 19.5512 1.33168 19.1211 1.73199 19.1211H2.41823",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.361 3.073L18.4525 2.97114L19.2074 2.111C19.3904 1.89597 19.3675 1.56776 19.1502 1.38668L18.8414 1.12637C18.6241 0.933973 18.2924 0.967925 18.1094 1.18296L17.2859 2.13364L16.4396 3.10695L3.58398 17.8424C3.42386 18.0348 3.43529 18.7026 3.84704 18.7478C4.6934 18.7478 9.07392 18.6007 12.4937 14.7754C14.4723 12.5684 15.17 9.76168 14.0606 8.53938C13.9348 8.39225 13.9348 8.17722 14.0606 8.03009L17.5261 4.05762L18.361 3.073Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeryTools);
export default __webpack_public_path__ + "static/media/surgeryTools.9a5e2b13c0b0e77e9fa6437ebf8c6cc2.svg";
export { ForwardRef as ReactComponent };